import { FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import styles from './styles.less';

export enum ThemeContainerBackground {
    Body = 'body',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    Transparent = 'transparent',
}

export enum ThemeContainerVariant {
    Day = 'day',
    Night = 'night',
}

export interface ThemeContainerProps {
    variant?: ThemeContainerVariant;
    background?: ThemeContainerBackground;
}

const ThemeContainer: FC<PropsWithChildren<ThemeContainerProps>> = ({
    variant = ThemeContainerVariant.Day,
    background = ThemeContainerBackground.Body,
    children,
}) => {
    const classes = classnames({
        'magritte-day-theme': variant === ThemeContainerVariant.Day,
        'magritte-night-theme': variant === ThemeContainerVariant.Night,
        [styles[`theme-container_background-${background}`]]: true,
    });

    return (
        <div>
            <div className={classes}>{children}</div>
        </div>
    );
};

export default ThemeContainer;
